/* eslint no-underscore-dangle: 0 */
/* eslint camelcase: 0 */
/* eslint dot-notation: 0 */
/* eslint no-param-reassign: 0 */
import { SERIAL_SETUP, findPinMode } from './helpers';

// bluetooth_name usa su propia clave de setup (no 'setup_serial') porque
// necesita además el delay(5000) para que el módulo entre en modo comando AT.

export const blue_read = (block, generator) => {
  generator.setups_['setup_serial'] = SERIAL_SETUP;
  return ['Serial.read()', generator.ORDER_ATOMIC];
};

export const bluetooth_name = (block, generator) => {
  const name = generator.valueToCode(block, 'DATOIN', generator.ORDER_ATOMIC) || '';
  const { code, pin } = findPinMode(name);
  generator.setups_['setup_bluetooth_'] = 'Serial.begin(9600);\ndelay(5000);';
  return `${code}Serial.print("AT+NAME ${pin.replace(/"/g, '')}");\ndelay(5000);\n`;
};

export const bt_serial_available = (block, generator) => {
  const branch = generator.statementToCode(block, 'DO').replace(/&quot;/g, '"');
  return `if (Serial.available()>0){\n${branch}\n}\n`;
};
